// extracted by mini-css-extract-plugin
export default {"meter":"RenownCategory_meter__ru7Qp","empty":"RenownCategory_empty__gJ18b"};